import React, { useState } from 'react';
import { useApiConfig } from '../context/ApiConfigContext';

export default function ApiConfigModal({ onClose }) {
  const { baseUrl, token, saveConfig } = useApiConfig();
  const [urlVal, setUrlVal] = useState(baseUrl);
  const [tokenVal, setTokenVal] = useState(token);
  const [showToken, setShowToken] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    saveConfig(urlVal.trim(), tokenVal.trim());
    setSaved(true);
    setTimeout(() => {
      setSaved(false);
      onClose();
    }, 700);
  };

  const handleKeyDown = e => {
    if (e.key === 'Escape') onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose} onKeyDown={handleKeyDown}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
            API Configuration
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="modal-body">
          <p className="modal-desc">
            Set your base URL and Bearer token. They are stored locally in your browser.
            The token is sent as <code>Authorization: Bearer …</code> on every test request — not as a query parameter.
          </p>

          <div className="modal-field">
            <label className="modal-label">Base URL</label>
            <input
              className="modal-input"
              type="url"
              placeholder="https://dev.api.lobees.com"
              value={urlVal}
              onChange={e => setUrlVal(e.target.value)}
              autoFocus
            />
            <div className="modal-hint">Your API server — no trailing slash</div>
          </div>

          <div className="modal-field">
            <label className="modal-label">Bearer Token</label>
            <div className="modal-token-wrap">
              <input
                className="modal-input"
                type={showToken ? 'text' : 'password'}
                placeholder="Paste your JWT here"
                value={tokenVal}
                onChange={e => setTokenVal(e.target.value)}
              />
              <button
                className="token-eye-btn"
                onClick={() => setShowToken(s => !s)}
                aria-label={showToken ? 'Hide token' : 'Show token'}
                tabIndex={-1}
              >
                {showToken ? (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
            <div className="modal-hint">
              Sent as <code>Authorization: Bearer …</code> header on every test request.
              Get your token from <code>GET /api/auth/token</code>.
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="modal-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="modal-save-btn" onClick={handleSave}>
            {saved ? '✓ Saved!' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
